import React from 'react';
import { Modal, LoadingButton } from '@spotify-internal/anchor-ds';
import { paths } from 'client/shared/Paths';
import { useT } from 'client/i18n/hooks/useT';
import { ButtonSecondary, TextLink } from '@spotify-internal/encore-web';

type Props = {
  hideConfirmationModal: () => void;
  handleSubmit: () => void;
  status: string;
};

const RedirectConfirmationModal = ({
  hideConfirmationModal,
  handleSubmit,
  status,
}: Props) => {
  const t = useT();
  return (
    <Modal
      aria-labelledby="redirect-confirmation-modal"
      isShowing
      isShowingCloseButton
      onClose={hideConfirmationModal}
    >
      <Modal.Title id="redirect-confirmation-modal">
        {t(
          'PodcastAvailabilityScreen.RSSDistribution.RedirectUrl.RedirectConfirmationModal.Title',
          'Are you sure you want to redirect your podcast?',
          'Redirect podcast confirmation modal title'
        )}
      </Modal.Title>
      <Modal.Body>
        {t(
          'PodcastAvailabilityScreen.RSSDistribution.RedirectUrl.RedirectConfirmationModal.Message',
          'After redirecting, your podcast will no longer be hosted on Anchor.',
          'Redirect podcast confirmation modal message'
        )}
      </Modal.Body>
      {status === 'error' && (
        <Modal.Error>
          {t(
            'PodcastAvailabilityScreen.RSSDistribution.RedirectUrl.RedirectConfirmationModal.ErrorMessage',
            'Something went wrong. Try again or if the issue persists, please {supportLink}.',
            'Podcast redirection failed error message',
            {
              supportLink: (
                <TextLink
                  href={paths.getHelpPage('home')}
                  target="_blank"
                  rel="noopener noreferrer"
                  key="podcast-availability-scren__contact-support-link"
                >
                  {t(
                    'Link.ContactSupport',
                    'contact support',
                    'contact support link text'
                  )}
                </TextLink>
              ),
            }
          )}
        </Modal.Error>
      )}
      <Modal.Footer>
        <ButtonSecondary
          onClick={hideConfirmationModal}
          disabled={status === 'loading'}
        >
          {t(
            'PodcastAvailabilityScreen.RSSDistribution.RedirectUrl.RedirectConfirmationModal.DontRedirectButtonLabel',
            'No, stay hosted on Anchor',
            'Dont redirect podcast button text'
          )}
        </ButtonSecondary>
        <LoadingButton
          color="red"
          onClick={handleSubmit}
          isLoading={status === 'loading'}
        >
          {t(
            'PodcastAvailabilityScreen.RSSDistribution.RedirectUrl.RedirectConfirmationModal.RedirectButtonLabel',
            'Yes, redirect my podcast',
            'Redirect podcast button text'
          )}
        </LoadingButton>
      </Modal.Footer>
    </Modal>
  );
};

export { RedirectConfirmationModal };
